export function itemAssetSlug(itemIdOrIconKey: string): string {
  return itemIdOrIconKey.replace(/_/g, '-');
}

export function itemIconUrl(itemIdOrIconKey: string): string {
  return `/assets/textures/item-icons/${itemAssetSlug(itemIdOrIconKey)}.webp`;
}

export function itemModelUrl(itemId: string): string {
  const slug = itemAssetSlug(itemId);
  const modelSlug = slug === 'shadow-stalker' ? 'shadow-stalker-staff' : slug;
  return `/assets/models/item-${modelSlug}.glb`;
}
